import Slider from './components/Slider';
import FloorSlider from './components/FloorSlider';
import EventBanner from './components/EventBanner';
import ImageSlider from './components/ImageSlider';
import Menu from './components/Menu';
import SubNav from './components/SubNav';
import LazyLoad from './components/LazyLoad';
import ToolTip from './components/ToolTip';

//import InstaFeed from './components/Instagram';
import RegisterInterestModal from './components/RegisterInterest';
import DownloadBrochure from './components/DownloadBrochure';

import Tabs from './components/Tabs';
import localAreaMap from './components/LocalAreaMap';
import overlapSlider from './components/OverlapSlider';
import AccordianComponent from './components/Accordian';
import EnquiryModalComponent from './components/EnquiryModal';
import VideoModal from './components/VideoModal';
import ImageFancyBox from './components/ImageFancybox';

import DevelopmentTabs from './components/DevelopmentTabs';
import MapComponent from './components/MapComponent';
import MapPage from './components/MapPage';
import Search from './components/Search';
import Countdown from './components/Countdown';
//import EmergencyBanner from './components/EmergencyBanner';
import DatePicker from './components/DatePicker';
import OfferPopup from './components/OfferPopup';
import SpecificationBlocks from './components/specification';

import axios from 'axios';

{
    Array.prototype.forEach.call(document.querySelectorAll('a[href^="#"]'), (anchor) => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
            document.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: 'smooth'
            });
        });
    });
}

{
    Slider();
    EventBanner();
    Menu();
    SubNav();
    FloorSlider();
    ImageSlider();
    LazyLoad();
    ToolTip();
    ImageFancyBox();
}

// {
//     let FancyBox = document.querySelector('data-fancybox="gallery"');
//     if (typeof FancyBox != "undefined" && FancyBox != null) {
//         ImageFancyBox();
//     }
// }

{
    let SpeciSection = document.querySelector('#specification');
    if (typeof SpeciSection != "undefined" && SpeciSection != null) {
        SpecificationBlocks();
    }
}

{
    let TriggerOfferPopup = document.querySelector('.offerModal');
    if (typeof TriggerOfferPopup != "undefined" && TriggerOfferPopup != null) {
        OfferPopup();
    }
  }

{
    let enquiryTriggerMapPage = document.querySelectorAll('.enquiryModal-trigger');
    if (typeof enquiryTriggerMapPage != "undefined" && enquiryTriggerMapPage != null)
    MapPage();
}

{
    let downloadBrochureModal = document.querySelector('.brochureDownloadModal__overlay');
    if (typeof downloadBrochureModal != "undefined" && downloadBrochureModal != null) DownloadBrochure(downloadBrochureModal);
}

{
    let tabElement = document.querySelector('.tabbed-area');
    if (typeof tabElement != "undefined" && tabElement != null)
    Tabs();
}

{
    let localAreaMapElement = document.querySelector('.localAreaMap--single');
    if (typeof localAreaMapElement != "undefined" && localAreaMapElement != null)
    localAreaMap();
}

{

    let modalClose = document.querySelector('.localAreaMap__modalClose');

    if (typeof modalClose != "undefined" && modalClose != null)
    modalClose.addEventListener('click', () => document.querySelector('.localAreaMap__modal').classList.remove('localAreaMap__modal--active'));
}

{
    let overlapSliderEl = document.querySelector('.overlapSlider');
    if (typeof overlapSliderEl != "undefined" && overlapSliderEl != null)
    overlapSlider();
}

{
    let accordianElement = document.querySelector('.accordian');
    if (typeof accordianElement != "undefined" && accordianElement != null)
    AccordianComponent();
}

{
    let enquiryModalElement = document.querySelector('.enquiryModal');
    if (typeof enquiryModalElement != "undefined" && enquiryModalElement != null)
    EnquiryModalComponent();
}

{
    let registerInterestModalElement = document.querySelector('.registerInterestModal__form');
    if (typeof registerInterestModalElement != "undefined" && registerInterestModalElement != null)
    RegisterInterestModal();
}

{
    let videoTriggerElements = document.querySelectorAll('.video-trigger');
    if (typeof videoTriggerElements != "undefined" && videoTriggerElements != null)
    VideoModal(videoTriggerElements);
}

{
    let downloadBrochureModal = document.querySelector('.brochureDownloadModal__overlay');
    if (typeof downloadBrochureModal != "undefined" && downloadBrochureModal != null) DownloadBrochure(downloadBrochureModal);
}

{
    let tabs = document.querySelector('.tabSection');
    if (typeof tabs != "undefined" && tabs != null) DevelopmentTabs();
}

{
    let mapComponent = document.querySelector('.map-component');
    if (typeof mapComponent != "undefined" && mapComponent != null) MapComponent();
}

{

    let sitePlanNode = document.getElementById('site-plan');

    if (typeof sitePlanNode != "undefined" && sitePlanNode != null) {

        const config = {
            attributes: true,
            childList: true,
            subtree: true
        };

        const callback = function(mutationsList, observer) {
            for( let mutation of mutationsList ) {
                if ( mutation.type === 'childList' ) {
                    Array.prototype.forEach.call(mutation.addedNodes, (node) => {
                        if (node instanceof HTMLElement) {
                            if (node.classList.contains('mapViewCard')) {
                                EnquiryModalComponent();
                            }
                        }
                    });
                }
            }
        };

        const observer = new MutationObserver(callback);

        observer.observe(sitePlanNode, config);

    }
}

{
    let searchApp = document.querySelector('.searchUnit');
    if (typeof searchApp != "undefined" && searchApp != null) {
        Search();
    }
}

{
    let countdown = document.querySelector('.countdown');
    if (typeof countdown != "undefined" && countdown != null) {
        Countdown();
    }
}

// {
//   EmergencyBanner();
// }

{
    const datePickerElement = document.querySelector('.custom_datepicker');
    if (typeof datePickerElement != "undefined" && datePickerElement != null) {
        DatePicker(datePickerElement);
    }
}

{
    const enquiryToggle = document.querySelector('.enquiryToggle');
    if (typeof enquiryToggle != "undefined" && enquiryToggle != null) {

        const radioElement = document.querySelector('.enquiryToggle').closest('li');

        const enquiryRadioButton = radioElement.lastElementChild.lastElementChild.firstElementChild.firstElementChild;
        const requestViewingRadioButton = radioElement.lastElementChild.lastElementChild.lastElementChild.firstElementChild;

        if (enquiryRadioButton.checked) {
            enquiryRadioButton.nextElementSibling.classList.add('checked')
        }

        requestViewingRadioButton.addEventListener('change', () => {
            if(requestViewingRadioButton.checked) {
                requestViewingRadioButton.nextElementSibling.classList.add('checked')
                enquiryRadioButton.nextElementSibling.classList.remove('checked');
            }
        });

        enquiryRadioButton.addEventListener('change', () => {
            if(enquiryRadioButton.checked) {
                enquiryRadioButton.nextElementSibling.classList.add('checked')
                requestViewingRadioButton.nextElementSibling.classList.remove('checked');
            }
        });

    }
}


// {
//  axios.get('https://graph.instagram.com/access_token?grant_type=ig_exchange_token&client_secret=a045024ad717e53f930e5e79cf2aab81&access_token=IGQVJXOE1Mb1dMUmtXcXJLV3l0OFR5Uk5ZAZAVAtUDFZAMjdsOEJNcHVLMi04Ui13d0VuUndVNWFtN1RiSGVrVGwwaHNFZAm93QzNDRGZAFWHg4RHNhUklLcnQyLTZAXS1V6SkpHVkpGTk1POFRJWmhCTGhLazE4VEZAhSFpreTdJ').then(response => console.log(response));
// }


// WEBPACK FOOTER //
// ./src/js/app/index.js